/* ============================================================
   BONHEUR - Aparicion al entrar en pantalla
   BigStudio 2026

   Regla de la casa: UN solo momento orquestado por seccion. Nada
   de efectos dispersos, que es justo lo que hace que un sitio se
   lea barato y generado.

   TRES SEGUROS CONTRA CONTENIDO INVISIBLE
   Animar con opacidad 0 tiene un riesgo real: si el disparador
   falla, el cliente ve una pagina en blanco. Aqui eso no puede
   pasar.

   1. El contenido nace VISIBLE en el CSS. La clase que lo esconde
      la agrega este script, asi que sin JavaScript se ve todo.
   2. Lo que ya esta en pantalla al cargar se marca de inmediato,
      sin esperar al observador. Cubre el caso de una pagina que
      abre ya desplazada.
   3. Red de seguridad a los 3 segundos: si el observador no marco
      NADA, se asume roto y se muestra todo de golpe.
   ============================================================ */
(function () {
  var root = document.documentElement;

  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (quieto || !('IntersectionObserver' in window)) return;

  root.classList.add('bh-anima');

  var RED_DE_SEGURIDAD_MS = 3000;
  var pendientes = [];
  var algunoVisto = false;

  function mostrar(el) {
    if (el.classList.contains('bh-visto')) return;
    el.classList.add('bh-visto');
    algunoVisto = true;
    var i = pendientes.indexOf(el);
    if (i > -1) pendientes.splice(i, 1);
  }

  function yaEnPantalla(el) {
    var r = el.getBoundingClientRect();
    var alto = window.innerHeight || root.clientHeight;
    return r.top < alto && r.bottom > 0;
  }

  var ver = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        mostrar(e.target);
        ver.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  function observar() {
    var nuevos = document.querySelectorAll('.bh-reveal:not(.bh-visto)');

    Array.prototype.forEach.call(nuevos, function (el) {
      // Seguro 2: lo que ya se ve, se muestra sin esperar a nadie.
      if (yaEnPantalla(el)) {
        mostrar(el);
        return;
      }
      pendientes.push(el);
      ver.observe(el);
    });

    // Seguro 3: si a los 3 segundos el observador no marco nada,
    // es que no esta funcionando. Antes contenido visible sin
    // animacion que contenido animado que nadie ve.
    window.setTimeout(function () {
      if (algunoVisto) return;
      pendientes.slice().forEach(mostrar);
    }, RED_DE_SEGURIDAD_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observar);
  } else {
    observar();
  }

  // El editor de temas re-renderiza secciones sin recargar la pagina.
  document.addEventListener('shopify:section:load', observar);
})();
